import comp from "./IBSkillsModal";
export default comp;
